// import React, { useState, useEffect, useContext } from "react";
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import Confetti from "react-confetti";
import ProfileCard from "../../Identity/CurrentYou/ProfileCard";
import ValuesTransitionAnimation from "./ValuesTransitionAnimation";
import stars from "../../../../../../assets/stars.png";
// import { UserContext } from ".././../../../../../UserContext.js";

const ValuesCompletion = ({ 
  top3Values, 
  userName, 
  profileImage, 
  currentIdentityData, 
  userId,
  subsectionId,
  onNext,
  onSubsectionChange,
}) => {
  const [showConfetti, setShowConfetti] = useState(false);  // ✅ Start false
  const [showValuesCard, setShowValuesCard] = useState(false);  // ✅ Start false
  const [showTransitionAnimation, setShowTransitionAnimation] = useState(false);
  const [showProfileCard, setShowProfileCard] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);  // ✅ NEW - Controls fade animation
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // const { user } = useContext(UserContext);

  const NEXT_SUBSECTION_ID = "f135631c-ac59-4ac1-8d68-7f522948d56f";

  // ✅ INITIAL FADE-IN: Trigger after mount
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      setFadeIn(true);
      setShowConfetti(true);
      setShowValuesCard(true);
    }, 300);  // 300ms delay for smooth entry

    return () => clearTimeout(initialTimer);
  }, []);

  // ✅ PHASE TRANSITIONS
  useEffect(() => {
    if (!showValuesCard) return;

    const confettiTimer = setTimeout(() => {
      setShowConfetti(false);
      setShowValuesCard(false);
      setShowTransitionAnimation(true);
    }, 5000);

    return () => clearTimeout(confettiTimer);
  }, [showValuesCard]);

  useEffect(() => {
    const handleResize = () =>
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleAnimationComplete = () => {
    setShowTransitionAnimation(false);
    setShowProfileCard(true);
  };

  const handleNavigateToFutureValues = async () => {
    setIsNavigating(true);
    try {
      onSubsectionChange?.(NEXT_SUBSECTION_ID);
    } catch (error) {
      console.error("Navigation error:", error);
      setIsNavigating(false);
    }
  };

  const profileData = {
    userName: userName || currentIdentityData?.userName || "User",
    profileImage: profileImage || currentIdentityData?.profileImage || null,
    currentTitle: currentIdentityData?.currentTitle || "SOFTWARE ENGINEER",
    location: currentIdentityData?.location || null,
    salary: currentIdentityData?.salary || null,
    experienceYears: currentIdentityData?.experienceYears || null,
    experienceMonths: currentIdentityData?.experienceMonths || null,
    technicalSkills: currentIdentityData?.technicalSkills || null,
    behaviors: currentIdentityData?.behaviors || null,
    advice: currentIdentityData?.advice || null,
    hobbies: currentIdentityData?.hobbies || null,
  };

  return createPortal(
    <div className="fixed inset-0 z-[9999] bg-white overflow-y-auto">
 
      {/* Confetti */}
      {showConfetti && (
        <div
          style={{
            animation: "fadeIn 0.6s ease-in-out",
          }}
        >
          <Confetti
            width={windowSize.width}
            height={windowSize.height}
            numberOfPieces={250}
            gravity={0.3}
            recycle={false}
            colors={["#FFD700", "#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4", "#FFEAA7"]}
          />
        </div>
      )}

      {/* FIXED TITLE AT TOP */}
      {!showProfileCard && (
        <div 
          className="absolute top-16 left-0 right-0 z-[10000]"
          style={{ 
            pointerEvents: "none",
            animation: fadeIn ? "fadeInDown 0.8s ease-out" : "none",
            opacity: fadeIn ? 1 : 0,
          }}
        >
          <div className="text-center">
            <h1
              style={{
                fontFamily: "Gotham",
                fontWeight: 350,
                fontSize: 32,
                lineHeight: "135%",
                letterSpacing: "0%",
                color: "#323232",
              }}
            >
              The 3rd key milestone in your adventure!
            </h1>
          </div>
        </div>
      )}

      {/* Main Content - Centered vertically */}
      <div className="relative z-10 w-full h-full flex items-center justify-center p-4 md:p-8">
        <div className="w-full max-w-[429px] mt-10">
          {/* Phase 1: Values Card (0-5s) */}
          {showValuesCard && (
            <div
              style={{
                width: 381,
                minHeight: 438,
                borderRadius: 22.2,
                border: "0.89px solid",
                borderImageSource: "linear-gradient(161.13deg, #D9D9D9 -6.67%, #707070 90.21%)",
                background: "#FFFFFF",
                boxShadow: "0px 8.88px 65.72px 0px rgba(0, 0, 0, 0.2)",
                animation: fadeIn ? "fadeInUp 0.8s ease-out" : "none",
                opacity: fadeIn ? 1 : 0,
              }}
              className="overflow-hidden flex flex-col items-center mx-auto relative"
            >
             
              {/* Header */}
              <div
                style={{
                  width: "100%",
                  height: 118,
                  background: "#0D1111",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "12px",
                }}
              >
                {/* LEFT STARS - Rotated */}
                <img
                  src={stars}
                  alt="Stars"
                  style={{
                    width: "24px",
                    height: "24px",
                    transform: "rotate(180deg)",
                    opacity: 0.9,
                  }}
                />

                {/* CENTER TITLE */}
                <h2
                  style={{
                    fontFamily: "Gotham",
                    fontWeight: 700,
                    fontSize: 23.33,
                    lineHeight: "120%",
                    letterSpacing: "0%",
                    textTransform: "uppercase",
                    color: "#FFFFFF",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Your Core Values
                </h2>

                {/* RIGHT STARS - Normal */}
                <img
                  src={stars}
                  alt="Stars"
                  style={{
                    width: "24px",
                    height: "24px",
                    opacity: 0.9,
                  }}
                />
              </div>

              {/* Top 3 Values in card - ✅ STAGGERED ANIMATION */}
              <div className="flex flex-col items-center justify-center py-8 gap-6 px-4">
                {top3Values.map((value, index) => (
                  <div
                    key={index}
                    style={{
                      width: 258,
                      height: 69,
                      borderRadius: 50,
                      border: "1px solid #CCCCCC",
                      background: "#54B0AF",
                      paddingTop: 17,
                      paddingBottom: 17,
                      paddingLeft: 46,
                      paddingRight: 46,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      animation: fadeIn ? `fadeInUp 0.6s ease-out ${0.3 + index * 0.15}s both` : "none",
                      opacity: fadeIn ? 1 : 0,
                    }}
                  >
                    <span
                      style={{
                        fontFamily: "Gotham",
                        fontWeight: 700,
                        fontSize: 20,
                        lineHeight: "160%",
                        letterSpacing: "0%",
                        color: "#FFFFFF",
                        textAlign: "center",
                      }}
                    >
                      {value}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Phase 3: Profile Card */}
          {showProfileCard && (
            <>
              <div
                style={{
                  animation: "fadeInUp 0.8s ease-out",
                }}
              >
                <ProfileCard
                  formData={profileData}
                  userId={userId}
                  onInputChange={() => {}}
                  headerLabel="CURRENT STATE"
                  editableName={false}
                  showKnownFor={true}
                  showCoreValues={true}
                  coreValues={top3Values}
                />
              </div>
              
              {/* Next Button */}
              <button
                onClick={handleNavigateToFutureValues}
                disabled={isNavigating}
                style={{
                  width: 429,
                  height: 69,
                  borderRadius: 20,
                  paddingTop: 22,
                  paddingBottom: 22,
                  paddingLeft: 20,
                  paddingRight: 20,
                  background: isNavigating ? "#999" : "#54B0AF",
                  fontFamily: "Gotham",
                  fontWeight: 350,
                  fontSize: 21,
                  lineHeight: "100%",
                  letterSpacing: "0%",
                  color: "#FFFFFF",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  animation: "fadeInUp 0.8s ease-out 0.3s both",
                  cursor: isNavigating ? "not-allowed" : "pointer",
                }}
                className="mt-6 shadow hover:bg-[#449d9c] transition-all"
              >
                <span className="font-gotham font-medium">{isNavigating ? "Loading..." : "Next: Future Value Mapping"}</span>
                <span className="flex items-center justify-center">
                  <span
                    className="flex items-center justify-center"
                    style={{
                      background: "#fff",
                      borderRadius: "50%",
                      width: 20,
                      height: 20,
                    }}
                  >
                    <svg width="18" height="18" fill="#54B0AF" viewBox="0 0 20 20">
                      <path
                        fillRule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </span>
                </span>
              </button>
            </>
          )}
        </div>
      </div>

      {/* Phase 2: Transition Animation (5-9.4s) */}
      {showTransitionAnimation && (
        <ValuesTransitionAnimation
          values={top3Values}
          onAnimationComplete={handleAnimationComplete}
        />
      )}

      {/* CSS for animations */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>,
    document.body
  );
};

export default ValuesCompletion;